import { useEffect, useState } from "react";
import { SwatchBook, Check, Sun } from "lucide-react";

const GROUNDS = [
  { key: "ivory", label: "Ivory", hint: "Warm ivory" },
  { key: "white", label: "White", hint: "Studio white" },
  { key: "lilac", label: "Lilac", hint: "Soft wash" },
];

function readGround() {
  try {
    const v = localStorage.getItem("klareet.ground");
    if (v && GROUNDS.some((g) => g.key === v)) return v;
  } catch (_e) { /* ignore */ }
  return "ivory";
}

/**
 * Preferences. Look-and-feel only, saved on this device. Klareet is
 * light by design (KLA-048), so the only look choice is the ground.
 */
export default function PreferencesScreen() {
  const [ground, setGround] = useState(readGround());

  // Klareet is light by design. Clear any dark class a browser may
  // still carry from before the dark theme was removed.
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-ground", ground);
    try { localStorage.setItem("klareet.ground", ground); } catch (_e) { /* ignore */ }
  }, [ground]);

  return (
    <div className="max-w-3xl mx-auto px-5 pt-8 pb-24">
      <div className="k-label mb-2">account</div>
      <h1 className="klareet-serif mb-2" style={{ fontSize: "clamp(1.8rem, 4vw, 2.4rem)", lineHeight: 1.1 }} data-testid="preferences-title">
        Preferences.
      </h1>
      <p className="k-hero-sub mb-6">These are saved on this device, so they follow this browser, not your account.</p>

      <div className="k-card mb-5" data-testid="pref-ground">
        <div className="k-label mb-3 flex items-center gap-2"><SwatchBook size={14} /> background</div>
        <div className="flex flex-wrap gap-2">
          {GROUNDS.map((g) => (
            <button
              key={g.key}
              onClick={() => setGround(g.key)}
              className={`k-btn ${ground === g.key ? "k-btn-primary" : "k-btn-ghost"}`}
              data-testid={`pref-ground-${g.key}`}
              title={g.hint}
            >
              {ground === g.key && <Check size={13} />} {g.label}
            </button>
          ))}
        </div>
      </div>

      <div className="k-card" data-testid="pref-light-note">
        <div className="k-label mb-2 flex items-center gap-2"><Sun size={14} /> theme</div>
        <p className="k-quiet !text-sm" style={{ lineHeight: 1.55 }}>
          Klareet stays light and bright on purpose. One look, easy on the eyes, same for everyone.
        </p>
      </div>
    </div>
  );
}
